export enum CancelRequestType {
  Schedule = 'Schedule',
  Now = 'Now',
}

export enum RefundRequestType {
  none = 'none',
  full = 'full',
  prorated = 'prorated',
  custom = 'custom',
}

export enum FormFields {
  cancelRequestType = 'cancelRequestType',
  refundRequestType = 'refundRequestType',
  customAmount = 'customAmount',
}

export type FormValues = {
  [FormFields.cancelRequestType]: CancelRequestType
  [FormFields.refundRequestType]: RefundRequestType
  [FormFields.customAmount]: string
}
